import { z } from 'zod';
import { IsoDateTime, Uuid } from './common.js';
import { ActorType } from './audit.js';
/**
 * Domain events (transactional outbox). Naming: `<module>.<entity>.<past-tense verb>`.
 * Payloads carry ids and changed field names, not personal data; subscribers re-read what they need.
 */
export const EventEnvelope = z.object({
    id: z.string(), // outbox_events.id (bigint as string)
    event: z.string(),
    tenantId: Uuid.nullable(),
    occurredAt: IsoDateTime,
    actor: z.object({ type: ActorType, id: Uuid.nullable() }),
    payload: z.record(z.string(), z.unknown()),
});
export const CORE_EVENTS = {
    'core.tenant.created': z.object({ tenantId: Uuid }),
    'core.tenant.updated': z.object({ tenantId: Uuid, fields: z.array(z.string()) }),
    'core.tenant.status_changed': z.object({ tenantId: Uuid, status: z.string() }),
    'core.module.enabled': z.object({ moduleKey: z.string() }),
    'core.module.disabled': z.object({ moduleKey: z.string() }),
    'core.user.created': z.object({ userId: Uuid }),
    'core.user.updated': z.object({ userId: Uuid, fields: z.array(z.string()) }),
    'core.user.deleted': z.object({ userId: Uuid }),
    'core.role.created': z.object({ roleId: Uuid }),
    'core.role.updated': z.object({ roleId: Uuid, fields: z.array(z.string()) }),
    'core.role.deleted': z.object({ roleId: Uuid }),
    'core.settings.updated': z.object({
        moduleKey: z.string(),
        paths: z.array(z.string()),
        /** Present for site or group settings (ADR 0013); absent for tenant-level settings. */
        scope: z.enum(['site', 'group']).optional(),
        scopeId: z.uuid().optional(),
    }),
};
//# sourceMappingURL=events.js.map